import {
  useBoolean,
  useToastr,
  usePagination,
  paginationReturnType,
  usePaginationSessionStorage,
  useTabStorage
} from '@laxmimanogna/code-quick-components';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import auditRepository from '../repositories/AuditRepository';
import { ALL, ARCHIVED, NEW_UPLOAD, REBUTTAL } from '../constants/Filter';
import { toTitleCase } from '../utils/common.utils';
import { AuthContext } from '../providers/AuthProvider';
import { successToast } from '../components/successToast';
import { AUDITED, FILTER_OPTIONS, FILTER_OPTIONS_TO_CHART_STATUS_MAP } from '../constants/constants';
import { SuccessToastIcon } from '../constants/IconData';
import { DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME } from '../pages/assigned_audits/constants';

export const AuditContext = createContext({
  isAuditUploadListLoading: false,
  isUpdating: false,
  isUserList: false,
  isSpecialtyList: false,

  auditUploadList: [],
  specialties: [],
  users: [],
  auditArchivedList: [],
  auditNewUploadsList: [],
  auditRebuttalsList: [],
  auditedList: [],

  getAuditUpload: paginationReturnType,
  getAuditNewUploads: paginationReturnType,
  getAuditArchived: paginationReturnType,
  getAuditRebuttals: paginationReturnType,
  getAudited: paginationReturnType,

  getAllSpecialties: async () => { },
  getAllUsers: async () => { },
  requestMissingInfo: async () => { },
  markAsUrgent: async () => { },
  getAuditorList: async () => { },
  loadSpecialtyAuditors: async () => { },
  deleteUploadedFile: async () => { },
  assignSelf: async auditRowID => { },

  isDeleteUpload: false,
  isReqMissing: false,
  isMarkedAsUrgent: false,
  isUpdatingAuditorList: false,
  isAssigningChartToSelf: false,

  isSplitAudit: false,
  createSplitAudit: async () => { },

  isFetchingNewUploads: false,
  isfettchingAuditArchived: false,
  isFetchingRebuttals: false,
  isFetchingAudit: false,


  // for version 2 of audit sheet
  getAllCharts: async () => { },
  allCharts: [],
  isAllChartLoading: false,
  isFetchingSpecialties: false,
  getClientSpecialties: async () => {},
  isFetchingClientHospitals: false,
  getClientHospitals: async () => {},
  updateChartsV2: async () => {},
  isUpdatingCharts: false,
  isFetchingReviewers: false,
  // fetches reviewers, iff he/she has all the specialties mentioned in the api call. 
  getCommonReviewers: async () => {},
  getReviewers: async () => {},
  updateFilterParams: async () => {},
  chartStatusFilters: 'ALL',
  isAllChartsLoading: false,

  mergeCharts: async () => {},
  isMergingCharts: false,
});

const AuditProvider = props => {
  const toast = useToastr();
  const tabStorage = useTabStorage();

  const authContext = useContext(AuthContext);

  const [isAuditUploadListLoading, iaState] = useBoolean(false);
  const [isUpdating, iu1State] = useBoolean(false);
  const [isUserList, iuState] = useBoolean(false);
  const [isSpecialtyList, isState] = useBoolean(false);
  const [isUpdatingAuditorList, ialState] = useBoolean(false);
  const [isSplitAudit] = useBoolean(false);
  const [isDeleteUpload, idState] = useBoolean(false);
  const [isMergingCharts, imcState] = useBoolean(false);
  const [isAssigningChartToSelf, iactsState] = useBoolean(false);

  const [isReqMissing, rmState] = useBoolean(false);
  const [isMarkedAsUrgent, imState] = useBoolean(false);

  const [isFetchingNewUploads, ifnuState] = useBoolean(false);

  const [auditUploadList, setAuditUploadList] = useState([]);
  const [auditNewUploadsList, setAuditNewUploadsList] = useState([]);
  const [auditArchivedList, setAuditArchivedList] = useState([]);
  const [auditRebuttalsList, setAuditRebuttalsList] = useState([]);
  const [isfettchingAuditArchived, ifaaState] = useBoolean(false);
  const [auditedList, setAuditedList] = useState([]);
  const [isFetchingRebuttals, ifrState] = useBoolean(false);

  const [specialties, setSpecialties] = useState([]);
  const [users, setUsers] = useState([]);

  const [auditUploadListCount, setAuditUploadListCount] = useState(0);
  const [auditNewUploadsListCount, setAuditNewUploadsListCount] = useState(0);
  const [auditArchivedListCount, setAuditArchivedListCount] = useState(0);
  const [auditRebuttalsListCount, setAuditRebuttalsListCount] = useState(0);
  const [auditedListCount, setAuditedListCount] = useState(0);

  const getAuditUpload1 = usePagination(getAuditUpload);
  const getAuditNewUploads1 = usePagination(getAuditNewUploads);
  const getAuditArchived1 = usePagination(getAuditArchived);
  const getAuditRebuttals1 = usePagination(getAuditRebuttals);
  const getAudited1 = usePagination(getAudited);
  const getAllCharts1 = usePagination(getAllCharts)
  const [isFetchingAudit, ifaState] = useBoolean(false);

  // for version 2
  const [allCharts, setAllCharts] = useState([])
  const [isAllChartsLoading, iaclState] = useBoolean(false);
  const [isFetchingClientHospitals, ifhState] = useBoolean(false);
  const [isFetchingSpecialties, ifsState] = useBoolean(false);
  const [isFetchingReviewers, ifrvState] = useBoolean(false);
  const [isUpdatingCharts, iucState] = useBoolean(false);
  const [chartStatusFilters, setChartStatusFilters] = useState(FILTER_OPTIONS_TO_CHART_STATUS_MAP[FILTER_OPTIONS[tabStorage.getTab() || 0]])

  const {
    getPaginationSession
  } = usePaginationSessionStorage();

  const initialFilterParams = useMemo(() => ({
    newUploadStatus: '',
    // this will maintain the search text when we move to audit sheet and return. It will highlight the proper text
    searchText: getPaginationSession(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME)?.search || '',
  }), []);

  const [filterParams, setFilterParams] = useState(
    Object.assign({}, initialFilterParams)
  );

  const getFilterParams = () => {
    const queryParams = {};
    const { searchText, ordering } = filterParams;
    if (searchText) queryParams['search'] = searchText;
    if (ordering) queryParams['ordering'] = ordering;
    return queryParams;
  };

  async function getAllCharts (paginationParams) {
    const filterParams = getFilterParams();
    // filterParams['user'] = SELF
    iaclState.on();
    try {
      let payload = { ...filterParams, ...paginationParams}
      if (chartStatusFilters && !('chart_statuses' in payload)) {
        payload['chart_statuses'] = chartStatusFilters
      }
      if ('chart_statuses' in payload && !payload.chart_statuses) {
        delete payload.chart_statuses;
      }
      const response = await auditRepository.getCharts(payload)
      const annotatedResponse = response.results.map(val => ({...val, batch_providers: [...new Set(val.subRows.map(row => (row.providers ?? []).map(chartProv => chartProv.name)).flat().filter(name => !!name))]}))
      setAllCharts(annotatedResponse)
      return {...response, results: annotatedResponse};
    } catch (err) {
        toast.showError({
            description: `Something went wrong`,
        });
    } finally {
        iaclState.off()
    }
  }

  async function getCommonReviewers(payload) {
    try {
      ifrvState.on();
      const response = await auditRepository.getReviewers(payload);
      return response;
    } catch (err) {
      toast.showError({
        description: err.cause.detail
      });
      return {error: err.cause.detail};
    } finally {
      ifrvState.off();
    }
  }

  async function getReviewers(payload) {
    try {
      ifrvState.on();
      const response = await auditRepository.getReviewers({union: true, ...payload});
      return response;
    } catch (err) {
      toast.showError({
        description: err.cause.detail
      });
      return {error: err.cause.detail};
    } finally {
      ifrvState.off();
    }
  }

  async function getClientSpecialties(idMap) {
    try {
      ifsState.on();
      const response = await auditRepository.getClientSpecialties(idMap);
      return response;
    } catch (err) {
      toast.showError({
        description: `Unable to load specialties. ${err}`
      })
    } finally {
      ifsState.off();
    }
  }

  async function getClientHospitals(idMap) {
    try {
      ifhState.on();
      const response = await auditRepository.getClientHospitals(idMap);
      return response;
    } catch (err) {
      toast.showError({
        description: `Unable to load hospitals. ${err}`
      })
    } finally {
      ifhState.off();
    }
  }

  // currently this function is used to update specialty, auditors, providers
  async function updateChartsV2(payload, batchIdx) {
    let chartIds = null;
    try {
      iucState.on();
      const response = await auditRepository.updateChartsV2(payload);
      
      // if we need to update all the charts in that batch
      let chartIds = null;
      if ('batch_id' in payload) {
        chartIds = new Set(allCharts[batchIdx].map(chart => chart.id));
      } else {
        chartIds = new Set(payload.chart_ids)
      }
      
      const ALLOWED_KEYS = ['specialty', 'auditor', 'qa'];
      const updateData = Object.fromEntries(
        Object.entries(response).filter(([key,_]) => ALLOWED_KEYS.includes(key))) 

      setAllCharts(prev => {
        let newData = [...prev];
        newData[batchIdx].subRows = (prev[batchIdx].subRows || []).map(chart => {
          if (!chartIds.has(chart.id)) {
            return chart;
          }
          return {...chart, ...updateData}
          });
      return newData;
      })

      toast.showSuccess({
        description: "Charts successfully updated",
        icon: <SuccessToastIcon />
      });

      return response;
    } catch (err) {
      toast.showError({
        description: err.cause.detail
      });
      return {error: err.cause.detail}
    } finally {
      iucState.off();
    }
  }

  const updateFilterParams = (update_dict) => {
    setFilterParams({...filterParams, ...update_dict})
  }

  async function getAuditUpload(paginationParams) {
    const filterParams = getFilterParams();
    if (ALL) {
      filterParams.status = ALL;
    }
    try {
      iaState.on();
      const response = await auditRepository.getAuditUploads({
        ...paginationParams,
        ...filterParams,
      });
      setAuditUploadListCount(response.count);
      setAuditUploadList(response.results);
      return response;
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      iaState.off();
    }
  }

  async function getAuditNewUploads(paginationParams) {
    const filterParams = getFilterParams();
    if (NEW_UPLOAD) {
      filterParams.status = NEW_UPLOAD;
    }
    try {
      ifnuState.on();
      const response = await auditRepository.getAuditUploads({
        ...paginationParams,
        ...filterParams,
      });
      setAuditNewUploadsListCount(response.count);
      setAuditNewUploadsList(response.results);
      return response;
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      ifnuState.off();
    }
  }

  async function getAuditArchived(paginationParams) {
    const filterParams = getFilterParams();
    if (ARCHIVED) {
      filterParams.status = ARCHIVED;
    }
    try {
      ifaaState.on();
      const response = await auditRepository.getAuditUploads({
        ...paginationParams,
        ...filterParams,
      });
      setAuditArchivedListCount(response.count);
      setAuditArchivedList(response.results);
      return response;
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      ifaaState.off();
    }
  }

  async function getAuditRebuttals(paginationParams) {
    const filterParams = getFilterParams();
    if (REBUTTAL) {
      filterParams.status = REBUTTAL;
    }
    try {
      ifrState.on();
      const response = await auditRepository.getAuditUploads({
        ...paginationParams,
        ...filterParams,
      });
      setAuditRebuttalsListCount(response.count);
      setAuditRebuttalsList(response.results);
      return response;
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      ifrState.off();
    }
  }

  async function getAudited(paginationParams) {
    const filterParams = getFilterParams();
    if (AUDITED) {
      filterParams.status = AUDITED;
    }
    try {
      ifaState.on();
      const response = await auditRepository.getAuditUploads({
        ...paginationParams,
        ...filterParams,
      });
      setAuditedListCount(response.count);
      setAuditedList(response.results);
      return response;
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      ifaState.off();
    }
  }
  async function getAllSpecialties() {
    try {
      isState.on();
      const response = await auditRepository.getSpecialties();
      setSpecialties(response);
      if (response.length) {
        const specialtiesOptions = response.map(data => {
          const options = {
            label: data.name === 'ent' ? 'ENT' : toTitleCase(data.name),
            value: data.id,
          };
          return options;
        });
        setSpecialties(specialtiesOptions);
      }
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      isState.off();
    }
  }

  async function getAllUsers() {
    try {
      iuState.on();
      const response = await auditRepository.getUsers();
      if (response.length) {
        const userOptions = response.map(data => {
          const options = {
            ...data,
            label: toTitleCase(`${data.first_name} ${data.last_name}`),
            value: data.id,
          };
          return options;
        });
        setUsers(userOptions);
      }
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });
    } finally {
      iuState.off();
    }
  }
  // update specialties
  async function updateSubmittedChart(chartId, params) {
    try {
      iu1State.on();
      const response = await auditRepository.updateSubmittedChart(
        chartId,
        params
      );
      if (!response.result.assigned_auditor) {
        response.result.assigned_auditor = null;
      }
      updateAuditList(chartId, response.result);
    } catch (e) {
      toast.showError({
        description: `${e}`,
      });

      throw e;
    } finally {
      iu1State.off();
    }
  }
  // update list

  const updateAuditList = (auditListId, updatedParams) => {
    // check in auditUplodList
    let allAuditListIndex = auditUploadList.findIndex(auditlist => {
      return auditlist.id === auditListId;
    });

    if (allAuditListIndex > -1) {
      auditUploadList[allAuditListIndex] = {
        ...auditUploadList[allAuditListIndex],
        ...updatedParams,
      };
      setAuditUploadList([...auditUploadList]);
    }
    // check in new uploads
    let newUploadsListIndex = auditNewUploadsList.findIndex(auditlist => {
      return auditlist.id === auditListId;
    });
    if (newUploadsListIndex > -1) {
      if (updatedParams.status !== 'AWAITING ASSIGNMENT') {
        const newUploads = auditNewUploadsList.filter((_, index) => {
          return index !== newUploadsListIndex;
        });
        setAuditNewUploadsList([...newUploads]);
      } else {
        auditNewUploadsList[newUploadsListIndex] = {
          ...auditNewUploadsList[newUploadsListIndex],
          ...updatedParams,
        };
        setAuditNewUploadsList([...auditNewUploadsList]);
      }
    }
    // check in archived
    let filterArchivedListIndex = auditArchivedList.findIndex(auditlist => {
      return auditlist.id === auditListId;
    });
    if (filterArchivedListIndex > -1) {
      auditArchivedList[filterArchivedListIndex] = {
        ...auditArchivedList[filterArchivedListIndex],
        ...updatedParams,
      };
      setAuditArchivedList([...auditArchivedList]);
    }
    // check in rebuttals
    let filterRebuttalsListIndex = auditRebuttalsList.findIndex(auditlist => {
      return auditlist.id === auditListId;
    });
    if (filterRebuttalsListIndex > -1) {
      auditRebuttalsList[filterRebuttalsListIndex] = {
        ...auditRebuttalsList[filterRebuttalsListIndex],
        ...updatedParams,
      };
      setAuditRebuttalsList([...auditRebuttalsList]);
    }
    // check in rebuttals
    let filterAuditedListIndex = auditedList.findIndex(auditlist => {
      return auditlist.id === auditListId;
    });
    if (filterAuditedListIndex > -1) {
      auditedList[filterAuditedListIndex] = {
        ...auditedList[filterAuditedListIndex],
        ...updatedParams,
      };
      setAuditedList([...auditedList]);
    }
  }

  // ----------------------------------------------------------------
  const handleApplyFilter = selectedFilters => {
    setFilterParams(selectedFilters);
  };

  async function deleteUploadedFile(auditListId) {
    try {
      idState.on();
      await auditRepository.deleteUploadedFile(auditListId);
      filterAuditList(auditListId);
      const toastProps = {
        description: `${'Deleted Successfully'}`,
        header: 'Success!',
      };
      successToast(toast, toastProps);
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      idState.off();
    }
  }

  async function mergeCharts(targetChartId, chartIds) {
    try {
      imcState.on();
      const response = await auditRepository.mergeCharts(targetChartId, chartIds);
      const toastProps = {
        description: `${chartIds.length} chart${chartIds.length > 1 ? 's' : ''} merged successfully`,
        header: 'Success!',
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      const message = error.cause?.error || error.cause?.detail || error.message || error.toString();
      toast.showError({
        description: message,
      });
      return { error: message };
    } finally {
      imcState.off();
    }
  }

  // filtering the audit list when delete uploads for instant response;
  function filterAuditList(auditListId) {
    // check in new uploads
    setAllCharts(prev => {
      let newData = [...prev];
      newData = newData.map(batch => {
        return {...batch, subRows: batch.subRows.filter(chart => chart.id !== auditListId)}
      } );
      return newData;
    });

    let filterNewUploadsList = auditNewUploadsList.filter(auditlist => {
      return auditlist.id !== auditListId;
    });
    setAuditNewUploadsList(filterNewUploadsList);
    // check in archived
    let filterArchivedList = auditArchivedList.filter(auditlist => {
      return auditlist.id !== auditListId;
    });
    setAuditArchivedList(filterArchivedList);
    // check in rebuttals
    let filterRebuttalsList = auditRebuttalsList.filter(auditlist => {
      return auditlist.id !== auditListId;
    });
    setAuditRebuttalsList(filterRebuttalsList);
    //check in Audited
    let filterAuditedList = auditedList.filter(auditlist => {
      return auditlist.id !== auditListId;
    });
    setAuditedList(filterAuditedList);
  }

  async function requestMissingInfo(auditListId, formdata) {
    try {
      rmState.on();
      const res = await auditRepository.updateChart(auditListId, {
        formData: { request_missing_info: formdata },
      });
      const toastProps = {
        description: `${'Submitted '}`,
        header: 'Success!',
      };
      successToast(toast, toastProps);
      updateAuditList(auditListId, res.result);
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      rmState.off();
    }
  }

  async function markAsUrgent(auditListId, isUrgent) {
    try {
      imState.on();
      const response = await auditRepository.updateChart(auditListId, {
        formData: { urgent: isUrgent },
      });
      updateAuditList(auditListId, response.result);
      const toastProps = {
        description: `${'Submitted Success'}`,
        header: 'Success!',
      };
      successToast(toast, toastProps);
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      imState.off();
    }
  }

  async function assignSelf(chartId) {
    try {
      iactsState.on();
      const response = await auditRepository.updateChart(chartId, {
        formData: { assigned_auditor: authContext.currentUser.id },
      });
      updateAuditList(chartId, response.result);
      const toastProps = {
        description: `${'Assigned to Self'}`,
        header: 'Success!',
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      iactsState.off();
    }
  }

  async function loadSpecialtyAuditors() {
    try {
      await auditRepository.getAuditorList();
    } catch (e) { }
  }

  async function getAuditorList(specialtyId) {
    try {
      ialState.on();
      const auditors = await auditRepository.getAuditors(specialtyId);
      return auditors;
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      ialState.off();
    }
  }

  // -------------------------------------------------------

  async function createSplitAudit(uploadId, data) {
    const response = await auditRepository.createSplitAudit(uploadId, data);
    return response;
  }

  const mContext = {
    isAuditUploadListLoading,
    isUpdating,

    getAuditUpload: getAuditUpload1,
    getAuditNewUploads: getAuditNewUploads1,
    getAuditArchived: getAuditArchived1,
    getAuditRebuttals: getAuditRebuttals1,
    getAudited: getAudited1,
    loadSpecialtyAuditors,

    getAllSpecialties,
    specialties,
    getAllUsers,

    auditUploadList,
    isUserList,
    isSpecialtyList,
    auditNewUploadsList,
    auditArchivedList,
    auditRebuttalsList,
    auditedList,
    users,

    auditUploadListCount,
    auditNewUploadsListCount,
    auditArchivedListCount,
    auditRebuttalsListCount,
    auditedListCount,
    filterParams,
    handleApplyFilter,
    updateSubmittedChart,
    deleteUploadedFile,
    isDeleteUpload,
    mergeCharts,
    isMergingCharts,

    requestMissingInfo,
    isReqMissing,
    markAsUrgent,
    isMarkedAsUrgent,
    isUpdatingAuditorList,
    assignSelf,

    getAuditorList,
    isSplitAudit,
    createSplitAudit,

    isAssigningChartToSelf,

    isFetchingNewUploads,
    isfettchingAuditArchived,
    isFetchingRebuttals,
    isFetchingAudit,

    // 
    getAllCharts: getAllCharts1,
    allCharts,
    isAllChartsLoading,
    isFetchingSpecialties,
    getClientSpecialties,
    isFetchingClientHospitals,
    getClientHospitals,
    updateChartsV2,
    isUpdatingCharts,
    isFetchingReviewers,
    getCommonReviewers,
    getReviewers,
    updateFilterParams,
    chartStatusFilters,
    setChartStatusFilters
  };

  return (
    <AuditContext.Provider value={mContext}>
      {props.children}
    </AuditContext.Provider>
  );
};

export default AuditProvider;
